/**
 * @ipc/admin-ui · shared/lib · useIsMobile —
 * true при viewport < sm (640px). До mount — false (desktop-first),
 * чтобы не мигать SSR/гидрацию; на реальном мобиле переключится после mount.
 */
import { useEffect, useState } from 'react';

/** Tailwind `sm` breakpoint (min-width: 640px). */
export const SM_BREAKPOINT_PX = 640;

export function useIsMobile(breakpointPx: number = SM_BREAKPOINT_PX): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpointPx - 1}px)`);
    const onChange = (): void => {
      setIsMobile(mql.matches);
    };
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpointPx]);

  return isMobile;
}
